import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function AnalysisTileSkeleton() {
	return (
		<Card>
			<CardHeader>
				<CardTitle className="text-lg">
					<div className="h-5 w-48 rounded bg-muted animate-pulse" />
				</CardTitle>
				<div className="mt-1 space-y-1">
					<div className="h-4 w-full max-w-[200px] rounded bg-muted animate-pulse" />
					<div className="h-4 w-full max-w-[160px] rounded bg-muted animate-pulse" />
				</div>
			</CardHeader>
			<CardContent>
				<div className="flex items-center justify-between">
					<div className="h-3 w-16 rounded bg-muted animate-pulse" />
					<div className="h-3 w-20 rounded bg-muted animate-pulse" />
				</div>
			</CardContent>
		</Card>
	)
}
